import { render, staticRenderFns } from "./IconUser.vue?vue&type=template&id=cb24efc4&scoped=true&"
import script from "./IconUser.vue?vue&type=script&lang=ts&"
export * from "./IconUser.vue?vue&type=script&lang=ts&"
import style0 from "./IconUser.vue?vue&type=style&index=0&id=cb24efc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb24efc4",
  null
  
)

export default component.exports